<dx-alert [titlestring]="title" [content]="content" visible="true">
  <spa-button (clickedButton)="button.action($event)" [label]="button.label" slot="action" shape="primary"></spa-button>
</dx-alert>
